import { ImageIcon, User } from "lucide-react";
import { photoUrl } from "../../lib/api";

// Neutral placeholders for photos. Replace `src` with a real image to swap.
export const PhotoPlaceholder = ({ src, label = "Foto", className = "", testid }) =>
  src ? (
    <img src={src} alt={label} className={`object-cover ${className}`} data-testid={testid} />
  ) : (
    <div data-testid={testid} className={`flex flex-col items-center justify-center gap-2 bg-gradient-to-br from-slate-100 to-slate-200 text-slate-400 ${className}`}>
      <ImageIcon className="h-10 w-10" strokeWidth={1.5} />
      <span className="text-xs font-semibold uppercase tracking-widest">{label}</span>
    </div>
  );

export const Avatar = ({ fileId, name, size = 56, testid }) => {
  const src = photoUrl(fileId);
  const style = { width: size, height: size };
  return src ? (
    <img src={src} alt={name || "Docent"} style={style} className="shrink-0 rounded-full object-cover" data-testid={testid} />
  ) : (
    <div style={style} data-testid={testid} className="flex shrink-0 items-center justify-center rounded-full bg-gradient-to-br from-slate-100 to-slate-200 text-slate-400">
      <User style={{ width: size * 0.45, height: size * 0.45 }} strokeWidth={1.5} />
    </div>
  );
};
